// <%= javascript_pack_tag 'stages-map' %>

import Vue from 'vue/dist/vue.esm';
import StagesMap from '../stages-map.vue';

document.addEventListener('DOMContentLoaded', () => {
  const StagesMapApp = new Vue({
    el: '#stages_map_wrapper',
    components: {StagesMap}
  });
  window['__stages_map_app__'] = StagesMapApp;
});
